import * as swcHelpers from '@swc/helpers';
import { LineItemModels } from '@grandvisionhq/lib-visuals';
import { getLocalizedString, isNil } from '@grandvisionhq/utils';
import { toBaseLineItem } from './base-line-item.js';
import { getLineItemProduct } from './utils/get-line-item-product.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getProductA11yLabel } from './utils/get-product-a11y-label.js';
import { mapBundleChildLineItems } from './utils/map-bundle-child-line-items.js';

function toLens(lens) {
    const { pupillaryDistance , power , cylinder , axis , addition  } = lens;
    return swcHelpers.objectSpread({}, !isNil(pupillaryDistance) ? {
        pupillaryDistance: pupillaryDistance.toString()
    } : null, !isNil(power) ? {
        power: power.toString()
    } : null, !isNil(cylinder) ? {
        cylinder: cylinder.toString()
    } : null, !isNil(axis) ? {
        axis: axis.toString()
    } : null, !isNil(addition) ? {
        addition: addition.toString()
    } : null);
}
function getPrescription(typeDetails) {
    if (typeDetails.newPrescription && typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: LineItemModels.PrescriptionType.OCR_PRESCRIPTION,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    } else if (typeDetails.newPrescription) {
        return {
            type: LineItemModels.PrescriptionType.NEW_PRESCRIPTION,
            leftEye: toLens(typeDetails.newPrescription.leftLens),
            rightEye: toLens(typeDetails.newPrescription.rightLens)
        };
    } else if (typeDetails.isEmailPrescription) {
        return {
            type: LineItemModels.PrescriptionType.EMAIL_PRESCRIPTION
        };
    } else if (typeDetails.isExistingCustomer) {
        return {
            type: LineItemModels.PrescriptionType.EXISTING_CUSTOMER
        };
    } else if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: LineItemModels.PrescriptionType.PRESCRIPTION_FILE,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    }
    throw new Error('Missing prescription details in visual line item mapper');
}
const toGlassesBundleCartLineItem = (lineItem, typeDetails, intl, settings)=>{
    const product = getLineItemProduct(lineItem);
    const variant = product.masterData.current.variant;
    const imageUrl = getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled);
    const packageNames = lineItem.bundleLineItems.reduce((subtitle, childLineItem)=>{
        if (childLineItem.isMainBundleLineItem) {
            return subtitle;
        }
        return `${subtitle}${getLocalizedString(childLineItem.legacyProduct.masterData.current.name, intl.locale)}, `;
    }, '').slice(0, -2);
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, settings, intl), {
        imageUrl,
        type: 'GLASSES_BUNDLE',
        productType: 'prescription-glasses',
        title: `${getAttribute(variant, 'brand')} ${getAttribute(variant, 'brandModel')}`,
        subtitle: packageNames,
        altText: getProductA11yLabel(lineItem, intl),
        prescription: getPrescription(typeDetails),
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};

export { toGlassesBundleCartLineItem };
//# sourceMappingURL=glasses-bundle-line-item.js.map
